<template>
  <div class="recruit">
    <header>
      <a href="#/">{{platformName}}</a>
    </header>

    <h3>{{info.title}}
      <img
        :src="getUrl(info.companyLogo)"
        alt=""
      >

    </h3>
    <!-- <div class="item">
      <p>公司简介</p>
      <div v-html="info.companyIntro"></div>
    </div> -->

    <div class="item">
      <p>招聘简章</p>
      <div v-html="info.detail"></div>
    </div>

    <div class="item">
      <p>报名时间</p>
      <span>报名开始时间:{{info.startTime}}</span>
      <span>报名结束时间:{{info.endTime}}</span>
    </div>

    <div class="item">
      <p>附件下载</p>
      <div>
        <a
          v-if="info.post"
          :href="getUrl(info.post)"
        >岗位表</a>
        <a
          v-if="info.pledge"
          :href="getUrl(info.pledge)"
        >诚信承诺表</a>
        <a
          v-if="info.major"
          :href="getUrl(info.major)"
        >专业目录</a>
      </div>
    </div>

    <div
      class="signUpBtn"
      v-if="info.id"
    >
      <a @click="goSign">立即报名(建议使用谷歌浏览器)</a>
    </div>
  </div>
</template>
<script>
import { platformName } from '@/config/GlobalText'
import { recruitRes } from '@/api'
import FileUrlMixin from '@/mixins/FileUrlMixin'
import { storageUtil } from '@/utils'
export default {
  mixins: [FileUrlMixin],
  data() {
    return {
      platformName,
      info: {}
    }
  },
  created() {
    var { id } = this.$route.params
    this.getDetail(id)
  },
  methods: {
    getDetail(id) {
      recruitRes.getDetail({ id }).then(res => {
        this.info = res
      })
    },
    goSign() {
      //如果是管理员就跳转首页，考生跳转报名页面
      var userType = storageUtil.get('type')
      console.log(userType)
      if (userType == 1 || userType === null) {
        //跳转报名页面
        this.$router.push('/doSignUp/' + this.info.id)
      } else {
        //提示无权限，只有考生才能报名
        this.$message.warning('只有考生才能进行报名')
      }
    }
  },
  watch: {
    $route(to, from) {
      var { id } = to.params
      this.getDetail(id)
    }
  }
}
</script>

<style lang="scss" scoped>
body {
}
.recruit {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: $border-color;
  margin: auto;
  max-width: 1224px;
  height: 100%;
}
header {
  display: block;
  background-color: #002140;
  color: white;
  padding: 20px 10px;
  font-size: 18px;
}

h3 {
  text-align: center;
  margin: 0;
  padding: 30px 0 20px 0;
  position: relative;
  img {
    width: 200px;
    height: 40px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
.item {
  // color: #716f6f;
  background-color: white;
  padding: 0px 10px 12px 10px;
  margin: 10px 10px;
  border-radius: 4px;

  p {
    font-weight: bolder;
    display: inline-block;
    border-radius: 4px;
    position: relative;
    padding: 2px 0 2px 8px;
    &:before {
      content: '';
      height: 100%;
      width: 4px;
      background-color: $orange-color;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  div {
    text-indent: 12px;
  }
  span {
    display: block;
    margin: 6px 0;
  }
  a {
    text-decoration: underline;
    color: $gray-color;
    margin-right: 20px;
  }
}
.signUpBtn {
  padding-bottom: 30px;
  a {
    background-color: $orange-color;
    color: white;
    width: 80%;
    display: block;
    text-align: center;
    margin: 30px auto 0px auto;
    padding: 12px 0;
    border-radius: 4px;
  }
}
@media screen and (max-width: 768px) {
  h3 {
    padding: 30px 0 30px 0;
    img {
      position: relative;
      width: 60%;
      margin: 30px 0 0 0;
    }
  }
}
</style>
